import Is from "../is";

/**
 * Deep merge objects
 *
 * @param {any} target
 * @param {any[]} sources
 * @returns {object}
 */
export default function merge(target: any, ...sources: any[]): any {
  if (Is.empty(sources)) return target;

  const source = sources.shift();

  for (const key in source) {
    if (Is.object(source[key])) {
      if (!target[key]) Object.assign(target, { [key]: {} });

      merge(target[key], source[key]);
    } else {
      Object.assign(target, { [key]: source[key] });
    }
  }

  return merge(target, ...sources);
}
